import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo'
import { ProfileBadgeRoot } from './styled'

export interface ProfileBadgeProps {
  name: string
  color?: string
  className?: string
  /** Para celdas compactas (máx. ancho 80%). */
  compact?: boolean
}

/**
 * Badge de perfil LMS con color de fondo/borde (diseño modal Perfiles / Figma).
 */
export const ProfileBadge = ({
  name,
  color,
  className,
  compact = false,
}: ProfileBadgeProps) => (
  <ProfileBadgeRoot $color={color} $compact={compact} className={className}>
    {color === 'unset' && <FontAwesomeIcon icon={faCircleInfo} />}
    {name}
  </ProfileBadgeRoot>
)

export default ProfileBadge
